module.exports = __webpack_public_path__ + "img/14.aa32d692.jpg";